module.exports = __webpack_public_path__ + "54107fdb0baa1e9e2f59730997ef5399.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-420.webp.png
// module id = 365
// module chunks = 0